var playerLocation;
var pastSongs = [];
var genreArtists;
var currentKey;
var totalSongs;
var currentYtChannel;
var myUserId = '';
var songArtist = '';
var globalGenres = [
  {
    genre: "wow",
    name: "WoW",
    icon: "wow-music-50.png"
  },
  {
    genre: "edm",
    name: "EDM",
    icon: "electronic-music-50.png"
  },
  {
    genre: "pop",
    name: "Pop",
    icon: "pop.png"
  },
  {
    genre: "rap",
    name: "Rap",
    icon: "rap-50.png"
  },
  {
    genre: "dance",
    name: "Dance",
    icon: "electronic-music-50.png"
  },
  {
    genre: "rock",
    name: "Rock",
    icon: "rock-music-50.png"
  },
  {
    genre: "hiphop",
    name: "Hip Hop / R&B",
    icon: "hip-hop-music-50.png"
  },
  {
    genre: "multigenre",
    name: "Multi Genre",
    icon: "multi-genre-50.png"
  },
  {
    genre: "japanese",
    name: "Japanese",
    icon: "international-music-50.png"
  },
  {
    genre: "classical",
    name: "Classical",
    icon: "classic-music-48.png"
  },
  {
    genre: "korean",
    name: "Korean",
    icon: "international-music-50.png"
  },
  {
    genre: "metal",
    name: "Metal",
    icon: "rock-music-50.png"
  } 
];

var regions = [
  {
    code: "GB",
    location: "United Kingdom",
    img: '/src/img/charts/chart-gb.jpg'
  },
  {
    code: "US",
    location: "United States",
    img: '/src/img/charts/chart-us.jpg'
  },
  {
    code: "FR",
    location: "France",
    img: '/src/img/charts/chart-france.jpg'
  },
  {
    code: "DE",
    location: "Germany",
    img: '/src/img/charts/chart-germany.jpg'
  },
  {
    code: "IN",
    location: "India",
    img: '/src/img/charts/chart-india.jpg'
  },
  {
    code: "JP",
    location: "Japan",
    img: '/src/img/charts/chart-japan.jpg'
  },
  {
    code: "KR",
    location: "South Korea",
    img: '/src/img/charts/chart-south-korea.jpg'
  },
  {
    code: "AU",
    location: "Australia",
    img: '/src/img/charts/chart-australia.jpg'
  },
  {
    code: "RU",
    location: "Russia",
    img: '/src/img/charts/chart-russia.jpg'
  },
  {
    code: "PL",
    location: "Poland",
    img: '/src/img/charts/chart-poland.jpg'
  },
  {
    code: "AR",
    location: "Argentina",
    img: '/src/img/charts/chart-argentina.jpg'
  },
  {
    code: "BR",
    location: "Brazil",
    img: '/src/img/charts/chart-brazil.jpg'
  }

];

var separators = [
  ' -- ',
  '--',
  ' - ',
  ' -  ',
  ' – ',
  ' — ',
  ' _ ',
  '_',
  //' -', //may need to remove
  '- ', //may need to remove
  '–',
  '—',
  ':',
  '|',
  '///',
  ' / ',
  '_',
  '/',
  ' "',
  '「',
  ' 「',
  '『',
  ' 『',
  '／',
  '〜',
  //'(',
  " '"
];

function cleanMVPV (string) {
  return string
    .replace(/\s*\[\s*(?:off?icial\s+)?([PM]\/?V)\s*]/i, '') // [MV] or [M/V]
    .replace(/\s*\(\s*(?:off?icial\s+)?([PM]\/?V)\s*\)/i, '') // (MV) or (M/V)
    .replace(/\s*【\s*(?:off?icial\s+)?([PM]\/?V)\s*】/i, '') // 【MV】 or 【M/V】
    .replace(/[\s\-–_]+(?:off?icial\s+)?([PM]\/?V)\s*/i, '') // MV or M/V at the end
    .replace(/(?:off?icial\s+)?([PM]\/?V)[\s\-–_]+/, '') // MV or M/V at the start
    .replace(/\(not the( video)?\)\s*$/, '')
    // Lyrics videos
    .replace(/(\s*[-~_/]\s*)?\b(with\s+)?lyrics\s*/i, '')
    .replace(/\(\s*(with\s+)?lyrics\s*\)\s*/i, '')
}

function cleanFluff (string) {
  return cleanMVPV(string)
    .replace(/\s*\[[^\]]+]$/, '') // [whatever] at the end
    .replace(/^\s*\[[^\]]+]\s*/, '') // [whatever] at the start
    .replace(/\s*\([^)]*\bver(\.|sion)?\s*\)$/i, '') // (whatever version)
    .replace(/\s*[a-z]*\s*\bver(\.|sion)?$/i, '') // ver. and 1 word before (no parens)
    .replace(/\s*(of+icial\s*)?(music\s*)?video/i, '') // (official)? (music)? video
    .replace(/\s*(ALBUM TRACK\s*)?(album track\s*)/i, '') // (ALBUM TRACK)
    .replace(/\s*\(\s*of+icial\s*\)/i, '') // (official)
    .replace(/\s*\(\s*[0-9]{4}\s*\)/i, '') // (1999)
    .replace(/\s+\(\s*(HD|HQ|[0-9]{3,4}p|4K)\s*\)$/, '') // (HD) (HQ) (1080p) (4K)
    .replace(/[\s\-–_]+(HD|HQ|[0-9]{3,4}p|4K)\s*$/, '') // - HD - HQ - 720p - 4K
}

function cleanTitle (title) {
  return cleanFluff(title.trim())
    .replace(/\s*\*+\s?\S+\s?\*+$/, '') // **NEW**
    .replace(/\s*video\s*clip/i, '') // video clip
    .replace(/\s+\(?live\)?$/i, '') // live
    .replace(/\(\s*\)/, '') // Leftovers after e.g. (official video)
    .replace(/\[\s*]/, '') // Leftovers after e.g. [1080p]
    .replace(/【\s*】/, '') // Leftovers after e.g. 【MV】
    .replace(/^(|.*\s)"(.*)"(\s.*|)$/, '$2') // Artist - The new "Track title" featuring someone
    .replace(/^(|.*\s)'(.*)'(\s.*|)$/, '$2') // 'Track title'
    .replace(/^[/\s,:;~\-–_\s"]+/, '') // trim starting white chars and dash
    .replace(/[/\s,:;~\-–_\s"]+$/, '') // trim trailing white chars and dash
    .replace('M/V', '')
    .replace('[MV]', '')
    .replace('［HD］', '')
    .replace('[HD]', '')
    .replace(/MV/, '') // Leftovers after e.g. MV
    .replace('[FULL AUDIO]', '')
    .replace(/\s*(Audio*)?(audio*)/i, '') // (audio)
    .replace(/\(([Official Audio)]+)\)/, '') // (official audio)
    .replace('()', '')
    .replace('[M/V]', '')
}

function cleanArtist (artist) {
  return cleanFluff(artist.trim())
    .replace(/\s*[0-1][0-9][0-1][0-9][0-3][0-9]\s*/, '') // date formats ex. 130624
    .replace(/^[/\s,:;~\-–_\s"]+/, '') // trim starting white chars and dash
    .replace(/[/\s,:;~\-–_\s"]+$/, '') // trim trailing white chars and dash
    .replace('M/V', '')
    .replace('[M/V]', '')
    .replace('[MV]', '')
    .replace('[HD]', '')
}

function inQuotes (str, idx) {
  var openChars = '([{«'
  var closeChars = ')]}»]'
  var toggleChars = '"\''
  var open = {
    ')': 0,
    ']': 0,
    '}': 0,
    '»': 0,
    //'"': 0,
    '\'': 0,
  }
  for (var i = 0; i < idx; i++) {
    var index = openChars.indexOf(str[i])
    if (index !== -1) {
      open[closeChars[index]]++
    } else if (closeChars.indexOf(str[i]) !== -1 && open[str[i]] > 0) {
      open[str[i]]--
    } if (toggleChars.indexOf(str[i]) !== -1) {
      open[str[i]] = 1 - open[str[i]]
    }
  }

  return Object.keys(open).reduce(function (acc, k) { return acc + open[k] }, 0) > 0
}

function splitArtistTitle (str) {
  for (var i = 0, l = separators.length; i < l; i++) {
    var sep = separators[i]
    var idx = str.indexOf(sep)
    if (idx > -1 && !inQuotes(str, idx)) {
      return [ cleanArtist(str.slice(0, idx)), cleanTitle(str.slice(idx + sep.length)) ]
    }
  }
}

/**
 *  @param {string} songName - song name include artist and title
 */

function artistSplit(songName) {

  if (songName.includes(' / ')) {
    songArtist = songName.split(' / ');
  } else if (songName.includes(' _ ')) {
    songArtist = songName.split(' _ ');
  } else if (songName.includes(' | ')) {
    songArtist = songName.split(' | ');
  } else if (songName.includes(': ')) {
    songArtist = songName.split(': ');
  } else if (songName.includes('- ')) {
    songArtist = songName.split('- ');
  } else if (songName.includes(' ~ ')) {
    songArtist = songName.split(' ~ ');
  } else if (songName.includes(' – ')) {
    songArtist = songName.split(' – ');
  } else {
    songArtist = songName.split(' - ');
  }

  return songArtist;

}

/**
 * 
 * Set time in millieseconds
 */

function timeDate(typeDate) {

  var d = new Date();
  var n;
  if (typeDate === 'ms') {
    n = d.getTime();
  } else if (typeDate === 'month') {
    n = d.getMonth();
  } else if (typeDate === 'year') {
    n = d.getFullYear();
  } else {
    console.log('nothing specified');
  }

  return n;
}


function formatTimeUnit(input, unit){
  var index = input.indexOf(unit);
  var output = "00"
 if(index < 0){
   return output; // unit isn't in the input
 }

 if(isNaN(input.charAt(index-2))){
   return '0' + input.charAt(index-1);
 }else{
   return input.charAt(index-2) + input.charAt(index-1);
 }
}

function yt_duration(duration){
  var H = formatTimeUnit(duration, 'H');
  var M = formatTimeUnit(duration, 'M');
  var S = formatTimeUnit(duration, 'S');

 if(H == "00"){
   H = "";
 }else{
   H += ":"
 }

 return H + M + ':' + S ;
}


/**
 * 
 * @param {number} min - min value - set to 0
 * @param {number} max - max length of array
 * @param {number} currentSongIndex - current song index
 * 
 */

function getRandomIndex(min, max, currentSongIndex) {

  pastSongs.push(currentSongIndex);

  //don't repeat the last 5 songs played
  if (pastSongs.length > 5) {
    pastSongs.splice(0, 1);
  }

  //build a range from min - max numbers
  //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from
  var completeRange = Array.from({length:max - min + 1},(v, k) => k + min);
  //console.log(completeRange);

  //fillter the array to exclude songs already been played
  var filteredSong = [];
  for (var i = 0; i < completeRange.length; i += 1) {
      //check to see if the song isn't in the completeRange
      if (!pastSongs.includes(completeRange[i])) {
        filteredSong.push(completeRange[i]);
      }
  }
  //console.log(filteredSong)

  //randomise the numbers in the filteredSong array - this won't include currently played songs
  var randomSong = Math.floor(Math.random() * filteredSong.length);
  var nextSongId = filteredSong[randomSong];

  //console.log(pastSongs);
  //console.log(nextSongId);
  return nextSongId;

}

/**
 * 
 * @param {number} time - converts time from youtube api
 */

function formatTime(time) {
  time = Math.round(time);
  var minutes = Math.floor(time / 60),
      seconds = time - minutes * 60;
  seconds = seconds < 10 ? '0' + seconds : seconds;
  return minutes + ":" + seconds;
}

/**
 * 
 * @param {number} currentTime 
 * @param {number} getDuration 
 */
function updateTimerDisplay(currentTime, getDuration) {
    angular.element('#current-time').text(formatTime(currentTime));
    angular.element('#duration').text(formatTime(getDuration));
    angular.element('#current-time-queue').text(formatTime(currentTime));
    angular.element('#duration-queue').text(formatTime(getDuration));
    angular.element('#current-time-mobile').text(formatTime(currentTime));
    angular.element('#duration-mobile').text(formatTime(getDuration));
}

function timePlayed(currentTime) {
  return formatTime(currentTime);
}

/**
 * 
 * @param {number} currentTime 
 * @param {number} getDuration 
 */

function updateProgressBar(currentTime, getDuration) {
    angular.element('#progress-bar').val((currentTime / getDuration) * 100);
}

/**
 * 
 * @param {object} googleUser 
 * @param {object} firebaseUser 
 */

function _isUserEqual(googleUser, firebaseUser) {
  if (firebaseUser) {
    var providerData = firebaseUser.providerData;
    for (var i = 0; i < providerData.length; i++) {
      if (providerData[i].providerId === firebase.auth.GoogleAuthProvider.PROVIDER_ID &&
        providerData[i].uid === googleUser.getBasicProfile().getId()) {
        // We don't need to reauth the Firebase connection.
        return true;
      }
    }
  }
  return false;
}

/**
 * 
 * Write data of user to Firebase and also include their YT Channel ID, so other users can view playlists that are publicly available
 * 
 * @param {string} userId 
 * @param {string} name 
 * @param {string} email 
 * @param {string} imageUrl 
 * @param {string} channelId 
 */

function writeUserData(userId, name, email, imageUrl, channelId) {
  firebase.database().ref('users/' + userId).update({
    username: name,
    email: email,
    profile_picture : imageUrl
  });
}	
 

function addLinkedProfile(userId, providerName) {
  var ref = firebase.database().ref('users/' + userId).child('linkedProfiles');
  ref.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {
      console.log('Provider Already attached to the account');
    } else {
      snapshot.ref.push({
          prodviderName: providerName
      });
    }
  });
}

function updateLocalPlaylist(userId, musicString) {
  firebase.database().ref('users/' + userId).update({
    playlist: {
      music: musicString
    }
  });
}	  
  
function updateYTChannel(userId, youtubeId) {
  firebase.database().ref('users/' + userId).update({
    "ytChannel": youtubeId
  });
}

function removeLocalPlaylist(userId) {
  firebase.database().ref('users/' + userId).child('myPlaylist').remove();
}	    

/**
 * 
 * History Collection, for the users song plays, most played songs all split by month and year
 * Also able to split out popular channels they have listened to as well
 * Improved version of songPlays()
 * 
 * @param {string} userId 
 * @param {string} songDetails 
 * @param {number} updateCount 
 * 
 */

function historyCollection(userId, songDetails, updateCount) {
  let songInfo = JSON.parse(songDetails);

  let ref = firebase.database().ref('users/' + userId).child('history');
  let refUserId = ref.orderByChild('songId').equalTo(songInfo.songId);

  refUserId.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {

      //console.log('Song Exists already - updating played count');
      let currentKey = Object.keys(snapshot.val())[0];
      let updatePlayCount = snapshot.val()[currentKey].totalPlays;

      snapshot.forEach(function (child) {
        child.ref.update({"totalPlays": updatePlayCount + 1 });
      });

    } else {

      var currentUrl = window.location.href;

      if (currentUrl.includes('subs')) {
        //console.log('subs test')
        snapshot.ref.push({
            songTitle: songInfo.songTitle,
            songArtist: songInfo.songArtist,
            thumbnail: songInfo.thumbnail,
            songId: songInfo.songId,
            totalPlays: updateCount,
            subChannel: songInfo.subChannel,
            subChannelId: songInfo.subChannelId,
            subChannelLogo: songInfo.subChannelLogo,
            timestamp: timeDate('ms'),
            month: timeDate('month'),
            year: timeDate('year')
        });

      } else {
        snapshot.ref.push({
            songTitle: songInfo.songTitle,
            songArtist: songInfo.songArtist,
            thumbnail: songInfo.thumbnail,
            songId: songInfo.songId,
            totalPlays: updateCount,
            timestamp: timeDate('ms'),
            month: timeDate('month'),
            year: timeDate('year')
        });
      }
    }
  });    

}	  

 /**
 * 
 * Store channel history of the user
 * 
 * @param {string} userId 
 * @param {string} channelDetails 
 * 
 */

function channelHistory(userId, channelDetails, subChanVisits) {
  let channelInfo = JSON.parse(channelDetails);
  let ref = firebase.database().ref('users/' + userId).child('channelHistory');
  let refUserId = ref.orderByChild('subChannelId').equalTo(channelInfo.subChannelId);

  refUserId.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {

          //console.log('Song Exists already - updating played count');
          let currentKey = Object.keys(snapshot.val())[0];
          let updateVisitCount = snapshot.val()[currentKey].totalVisits;
  
          snapshot.forEach(function (child) {
            child.ref.update({"totalVisits": updateVisitCount + 1 });
          });

    } else {

      var currentUrl = window.location.href;

      if (currentUrl.includes('subs')) {
        snapshot.ref.push({
            subChannel: channelInfo.subChannel,
            subChannelId: channelInfo.subChannelId,
            subChannelLogo: channelInfo.subChannelLogo,
            totalVisits: subChanVisits,
            timestamp: timeDate('ms'),
            month: timeDate('month'),
            year: timeDate('year')
        });

      }
    }
  });    

}	    

/**
 * 
 * Temp idea to replace localstorage
 * 
 * @param {string} userId 
 * @param {string} songDetails 
 */

function localPlaylist(userId, songDetails) {
  var songInfo = JSON.parse(songDetails);
  //console.log(songDetails);
  var ref = firebase.database().ref('users/' + userId).child('myPlaylist');
  var refUserId = ref.orderByChild('songId').equalTo(songInfo.id);

  refUserId.off();
  //on is real time watch
  //refUserId.on('value', function (snapshot) {
  //once only checks on init
  refUserId.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {
      console.log('Song Exists already in playlist - remove');
      snapshot.forEach(function (child) {
        child.ref.remove();
      });
    } else {
      snapshot.ref.off();
      snapshot.ref.push({
          songName: songInfo.title,
          thumbnail: songInfo.thumbnail,
          songId: songInfo.id
      });
    }
  });    

}	  


/**
 * 
 * Store user history - playlist plays and viewing related artists
 * 
 * @param {string} userId - logged in users id
 * @param {string} historyDetails - playlist or artist details
 * @param {string} loggedMusicType - if its a playlist or featured artist
 * 
 */

function addHistory(userId, historyDetails) {

  var ref;
  ref = firebase.database().ref('users/' + userId + '/playlistHistory');
  
  ref.off();
  ref.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {
      var keys = [];
      snapshot.forEach(function(child) {
        var itemVal = child.val();
        var firstKey = Object.keys(snapshot.val())[0];
        keys.push(itemVal);
        if (keys.length > 50) {
          //console.log('Removing child '+ firstKey);
          ref.child(firstKey).remove();
        }
      });

      var i;
      var submitPlaylist = true;
      for (i = 0; i < keys.length; i++) {
        if (keys[i].playlistID === historyDetails.playlistID) {
          //console.log(keys[i].playlistID);
          //console.log("Playlist exists, don't add it again");
          submitPlaylist = false;
        }
      }   

      if (submitPlaylist) {
        snapshot.ref.off();
        snapshot.ref.push({
          playlistID: historyDetails.playlistID,
          thumbnail: historyDetails.playlistThumb.replace('hqdefault', 'mqdefault'),
          playlistName: historyDetails.playlistTitle,
          timeStamp: timeDate('ms')
        });
      }
    
    } else {
      
      snapshot.ref.off();
      snapshot.ref.push({
          playlistID: historyDetails.playlistID,
          thumbnail: historyDetails.playlistThumb,
          playlistName: historyDetails.playlistTitle,
          timeStamp: timeDate('ms')
      });
      
    }
  });    

}


/**
 * 
 * Store user history - playlist plays and viewing related artists
 * 
 * @param {string} userId - logged in users id
 * @param {string} artistHistory - playlist or artist details
 * 
 */

function addArtist(userId, artistHistory, altPhoto) {

  var ref;
  ref = firebase.database().ref('users/' + userId + '/artistHistory');
  ref.off();
  ref.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {
      var keys = [];
      snapshot.forEach(function(child) {
        var itemVal = child.val();
        var firstKey = Object.keys(snapshot.val())[0];
        keys.push(itemVal);
        if (keys.length > 50) {
          //console.log('Removing child '+ firstKey);
          ref.child(firstKey).remove();
        }
      });

      var i;
      var submitArtist = true;
      for (i = 0; i < keys.length; i++) {
        if (keys[i].artistID === artistHistory.artistID) {
          submitArtist = false;
        }
      }

      if (submitArtist) {
        snapshot.ref.off();
        snapshot.ref.push({
          artistName: artistHistory.artistName,
          artistThumb: altPhoto,
          artistID: artistHistory.artistID,
          timeStamp: timeDate('ms')
        });
      }
    
    } else {
      
      snapshot.ref.off();
      snapshot.ref.push({
        artistName: artistHistory.artistName,
        artistThumb: altPhoto,
        artistID: artistHistory.artistID,
        timeStamp: timeDate('ms')
      });
      
    }
  });    

}

/**
 * 
 * Temp idea for playlist submission by genre
 * 
 * @param {string} genre 
 * @param {string} playlistDetails 
 */

function addGenrePlaylist(genre, playlistDetails) {
  var playlistInfo = JSON.parse(playlistDetails);
  //console.log(playlistInfo);
  var ref = firebase.database().ref('genre/' + genre);
  var refUserId = ref.orderByChild('playlistID').equalTo(playlistInfo.playlistID);

  refUserId.off();
  refUserId.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {
      //snapshot.forEach(function (child) {
      //  child.ref.remove();
      //});
    } else {
      snapshot.ref.off();
      snapshot.ref.push({
          playlistID: playlistInfo.playlistID,
          thumbnail: playlistInfo.playlistThumb,
          playlistName: playlistInfo.playlistName
      });
    }
  });    

}	  

/**
 * 
 * Temp idea for saving featured channels for subs
 * 
 * @param {string} subID 
 * @param {string} featuredSuberinos 
 */

function addFeaturedChannels(subID, featuredSuberinos) {
  var subFeatInfo = featuredSuberinos;
  var ref = firebase.database().ref('featChannels/' + subID);
  var refUserId = ref.orderByChild("favChannel").equalTo(subID);
  refUserId.off();
  refUserId.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {
      console.log('feat channels for ' + subID + ' already exists');
      //snapshot.forEach(function (child) {
      //  child.ref.remove();
      //});
    } else {
      snapshot.ref.off();
      for (var i = 0, len = featuredSuberinos.length; i < len; i++) {
        snapshot.ref.push({
          channelId: featuredSuberinos[i].channelId,
          thumbnail: featuredSuberinos[i].thumbnail,
          title: featuredSuberinos[i].title,
          favChannel: subID
        });
      }
    }
  });    

}

/**
 * 
 * Temp idea for saving featured channels for subs
 * 
 * @param {string} subID 
 * @param {string} artistCollection 
 */

function addFoundArtists(userId, artistCollection) {
  var artistCollective = artistCollection;
  var ref;
  ref = firebase.database().ref('users/' + userId + '/musicfyArtists');
  ref.off();
  ref.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {
    } else {
      snapshot.ref.off();
      for (var i = 0, len = artistCollective.length; i < len; i++) {
        snapshot.ref.push({
          artistID: artistCollective[i].artistID,
          artistName: artistCollective[i].artistName,
          artistThumb: artistCollective[i].artistThumb,
        });
      }
    }
  });    

}	


/**
 * 
 * DJ mode - what was I thinking
 * 
 * @param {string} userId 
 * @param {string} songDetails - includes if the song playing state and youtube video id
 */

function djMode(userId, songDetails) {
  var songInfo = JSON.parse(songDetails);
  //console.log(songInfo);
  var ref = firebase.database().ref('users/' + userId + '/radio');

  //ref.off();
  //on is real time watch
  //refUserId.on('value', function (snapshot) {
  //once only checks on init
  ref.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {
      //console.log('test if something exists');
      snapshot.forEach(function (child) {
        child.ref.update(songInfo);
      });
    } else {
      //console.log('nothing exists')
      //snapshot.ref.off();
      snapshot.ref.push({
          index: songInfo.index,
          state: songInfo.state,
          songId: songInfo.songId
      });
    }
  });    

}

/**
 * 
 * Remove artists from Artist History
 * 
 * @param {string} userId 
 * @param {string} artistDetails 
 */

function removeArtist(userId, artistDetails) {
  var artistInfo = JSON.parse(artistDetails);
  //console.log(songDetails);
  var ref = firebase.database().ref('users/' + userId).child('artistHistory');
  var refUserId = ref.orderByChild('artistID').equalTo(artistInfo.artistID);

  refUserId.off();
  //on is real time watch
  //refUserId.on('value', function (snapshot) {
  //once only checks on init
  refUserId.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {
      console.log('remove artist from fb');
      snapshot.forEach(function (child) {
        child.ref.remove();
      });
    }
  });
}

/**
 * 
 * Remove playlists from Playlist History
 * 
 * @param {string} userId 
 * @param {string} playlistDetails 
 */

function removeHistoryPlaylist(userId, playlistDetails) {
  var playlistInfo = JSON.parse(playlistDetails);
  //console.log(songDetails);
  var ref = firebase.database().ref('users/' + userId).child('playlistHistory');
  var refUserId = ref.orderByChild('playlistID').equalTo(playlistInfo.playlistID);

  refUserId.off();
  //on is real time watch
  //refUserId.on('value', function (snapshot) {
  //once only checks on init
  refUserId.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {
      console.log('remove artist from fb');
      snapshot.forEach(function (child) {
        child.ref.remove();
      });
    }
  });
}


/**
 * 
 * Remove artists from Song History
 * 
 * @param {string} userId 
 * @param {string} songDetails 
 */

function removeSong(userId, songDetails) {

  var songInfo = JSON.parse(songDetails);

  console.log(songInfo);
  //console.log(songDetails);
  var ref = firebase.database().ref('users/' + userId).child('history');
  var refUserId = ref.orderByChild('songId').equalTo(songInfo.id);

  refUserId.off();
  //on is real time watch
  //refUserId.on('value', function (snapshot) {
  //once only checks on init
  refUserId.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {
      console.log('remove artist from fb');
      snapshot.forEach(function (child) {
        child.ref.remove();
      });
    }
  });
}


/**
 * 
 * Remove channel from Channel History
 * 
 * @param {string} userId 
 * @param {string} channelDetails 
 */

function removeHistoryChannel(userId, channelDetails) {
  var channelIno = JSON.parse(channelDetails);
  //console.log(songDetails);
  var ref = firebase.database().ref('users/' + userId).child('channelHistory');
  var refUserId = ref.orderByChild('subChannelId').equalTo(channelIno.subChannelId);

  refUserId.off();
  //on is real time watch
  //refUserId.on('value', function (snapshot) {
  //once only checks on init
  refUserId.once('value', function (snapshot) {
    if (snapshot.hasChildren()) {
      snapshot.forEach(function (child) {
        child.ref.remove();
      });
    }
  });
}


function requestNotification() {
  // Let's check if the browser supports notifications

  var notificatiOnoptions = {
    silent: true,
    icon: 'https://musicfy.co.uk/src/img/musicfy-notification-icon.png'
  }

  if (!("Notification" in window)) {
    console.log("This browser does not support desktop notification");
  }

  // Let's check whether notification permissions have already been granted
  else if (Notification.permission === "granted") {
    // If it's okay let's create a notification
    //var notification = new Notification("You've enabled music notifications", notificatiOnoptions);
    console.log("You've enabled music notifications");
  }

  // Otherwise, we need to ask the user for permission
  else if (Notification.permission !== "denied") {
    Notification.requestPermission().then(function (permission) {
      // If the user accepts, let's create a notification
      if (permission === "granted") {
        var notification = new Notification("You've enabled music notifications to display what song is playing!", notificatiOnoptions);

        setTimeout(function() {
          notification.close();
        }, 6000);
        
      }
    });
  }

  // At last, if the user has denied notifications, and you 
  // want to be respectful there is no need to bother them any more.
}

function adjustWidth() {
  var parentwidth = $(".musicfy-chart__info").width();
  $(".musicfy-chart__play").width(parentwidth);
}

var songAchivements = [
  {
    achRequired: 10,
    achMessage: "Achievement Unlocked: 10 Songs Played"
  },
  {
    achRequired: 50,
    achMessage: "Achievement Unlocked: 50 Songs Played"
  },
  {
    achRequired: 100,
    achMessage: "Achievement Unlocked: 100 Songs Played"
  },
  {
    achRequired: 250,
    achMessage: "Achievement Unlocked: 250 Songs Played"
  },
  {
    achRequired: 1000,
    achMessage: "Achievement Unlocked: 1000 Songs Played"
  },
  {
    achRequired: 2500,
    achMessage: "Achievement Unlocked: 2500 Songs Played"
  },
  {
    achRequired: 10000,
    achMessage: "Achievement Unlocked: 10000 Songs Played"
  },

];


$(document).ready(function () {

  //materilizecss modal init
  $('.modal').modal();

  var $menuContainer = document.querySelector('.musicfy-nav');
  var $offCanvasBg = document.querySelector('.offcanvasmilbebg');

  document.getElementById('musicfyHamburger').addEventListener('click', function () {
      $menuContainer.classList.toggle('menu-expand');
      $offCanvasBg.classList.toggle('offcanvasbg');
  });

  document.getElementById('offCanvasBackground').addEventListener('click', function () {
      $menuContainer.classList.toggle('menu-expand');
      $offCanvasBg.classList.toggle('offcanvasbg');
  });


});